export function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function cloneDeepHelper(val, seen) {
    switch (Object.prototype.toString.call(val)) {
        case '[object Array]': {
            if (seen.has(val)) {
                return seen.get(val);
            }
            const copy1 = val.slice(0);
            seen.set(val, copy1);
            copy1.forEach((child, i) => {
                copy1[i] = cloneDeepHelper(child, seen);
            });
            return copy1;
        }
        case '[object Object]': {
            if (seen.has(val)) {
                return seen.get(val);
            }
            const copy2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy2);
            Object.keys(val).forEach(key => {
                if (key !== '__widget') {
                    copy2[key] = cloneDeepHelper(val[key], seen);
                }
            });
            return copy2;
        }
        default:
            return val;
    }
}
export function cloneMapDeep(map) {
    if (!map) {
        return map;
    }
    const clonedMap = new Map();
    for (const [key, value] of map.entries()) {
        clonedMap.set(key, cloneDeep(value));
    }
    return clonedMap;
}
export function simpleClone(value) {
    return JSON.parse(JSON.stringify(value));
}
